export default __webpack_public_path__ + "assets/images/4c5980f5e741efc484e6a5fda70edc55.png";